export default "__VITE_ASSET__CrMPUFaG__"